export const homeNav = () => {
  const sections = document.querySelectorAll("section");
  const navLinks = document.querySelectorAll(".home-nav a");

  function updateActiveLink() {
    let currentSection = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      if (window.pageYOffset >= sectionTop - sectionHeight / 3) {
        currentSection = section.getAttribute("id");
      }
    });

    navLinks.forEach((link) => {
      link.classList.remove("isActive");
      if (link.getAttribute("data-active-link") === currentSection) {
        link.classList.add("isActive");
      }
    });
  }

  window.addEventListener("scroll", updateActiveLink);
  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const sectionId = this.getAttribute("data-active-link");
      const section = document.getElementById(sectionId);

      if (section) {
        section.scrollIntoView({ behavior: "smooth" });

        navLinks.forEach((el) => el.classList.remove("isActive"));
        this.classList.add("isActive");
      }
    });
  });
};

export const homeTabs = () => {
  const tabs = document.querySelectorAll(".home-why-us-tab");
  const scrollbar = document.querySelector(".scrollbar");

  if (!tabs.length || !scrollbar) return;

  const updateScrollbar = () => {
    let activeIndex = 1;
    let calculatedHeight = 0;

    tabs.forEach((tab, index) => {
      if (tab.classList.contains("isActive")) {
        activeIndex = index;
      }

      if (index <= activeIndex) {
        calculatedHeight += tab.offsetHeight;
      }
    });

    if (activeIndex === tabs.length - 1) {
      scrollbar.style.height = "100%";
    } else {
      scrollbar.style.height = `${calculatedHeight}px`;
    }
  };

  const handleTabClick = (clickedTab) => {
    tabs.forEach((tab) => tab.classList.remove("isActive"));
    clickedTab.classList.add("isActive");
    updateScrollbar();
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => handleTabClick(tab));
  });

  updateScrollbar();
};

export const homeTabsSlider = () => {
  const tabsContainer = document.querySelector(".home-why-us-tabs");
  const tabs = document.querySelectorAll(".home-why-us-tab");
  const dots = document.querySelectorAll(".home-why-us__dot");

  if (!tabsContainer || tabs.length < 2) return;

  let startX = 0;
  let currentIndex = 0;

  const updateActiveTab = (newIndex) => {
    if (newIndex < 0 || newIndex >= tabs.length) return;

    tabs.forEach((tab, index) => {
      tab.classList.toggle("isActive", index === newIndex);
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle("isActive", index === newIndex);
    });

    currentIndex = newIndex;
  };

  const handleSwipe = (deltaX) => {
    if (deltaX <= 50) {
      if (currentIndex > 0) {
        updateActiveTab(currentIndex - 1);
      }
    } else if (deltaX > 50) {
      if (currentIndex < tabs.length - 1) {
        updateActiveTab(currentIndex + 1);
      }
    }
  };

  tabsContainer.addEventListener("touchstart", (event) => {
    startX = event.touches[0].clientX;
  });

  tabsContainer.addEventListener("touchend", (event) => {
    const endX = event.changedTouches[0].clientX;
    const deltaX = startX - endX;
    handleSwipe(deltaX);
  });

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      updateActiveTab(index);
    });
  });
};
